export const modalTriggerCloseSelector =
  ".catifa-modal__close, .catifa-modal__backdrop";
const modalTriggerOpenSelector = ".catifa-modal-trigger";
const modalOpenClass = "catifa-modal--visible";
const modalClass = "catifa-modal";

const dismissCallbacks: { [key: string]: (() => void) | undefined } = {};

export const showModal = (
  modalId: string,
  onDismiss?: (() => void) | undefined,
) => {
  const modal = document.getElementById(modalId);
  if (modal) {
    dismissCallbacks[modalId] = onDismiss;
    modal.classList.add("catifa-modal--visible");
  }
};

export const manageModals = () => {
  document
    .querySelectorAll<HTMLElement>(modalTriggerOpenSelector)
    .forEach((trigger) => {
      trigger.addEventListener("click", (event) => {
        event.preventDefault();
        const modalId = trigger.dataset.target; // the id of the modal to open
        if (!modalId) {
          return;
        }
        showModal(modalId);
      });
    });

  document
    .querySelectorAll<HTMLElement>(modalTriggerCloseSelector)
    .forEach((trigger) => {
      trigger.addEventListener("click", (event) => {
        event.preventDefault();
        const modalId = trigger.dataset.target; // the id of the modal to close
        const isParentAModal =
          trigger.parentElement?.classList.contains(modalClass);
        if (!modalId && !isParentAModal) {
          return;
        }

        if (modalId) {
          dismissCallbacks[modalId]?.();
          const modal = document.getElementById(modalId);
          if (modal) {
            modal.classList.remove(modalOpenClass);
          }
        }
        if (isParentAModal) {
          trigger.parentElement?.classList.remove(modalOpenClass);
        }
      });
    });

  const closeModal = (e: KeyboardEvent) => {
    // Close modal on escape key press
    if (e.key === "Escape") {
      document.querySelectorAll(`.${modalOpenClass}`).forEach((modal) => {
        dismissCallbacks[modal.id]?.();
        modal.classList.remove(modalOpenClass);
      });
    }
  };

  window.removeEventListener("keyup", closeModal);
  window.addEventListener("keyup", closeModal);
};
